import { render, staticRenderFns } from "./Scholarships.vue?vue&type=template&id=29298564&"
import script from "./Scholarships.vue?vue&type=script&lang=js&"
export * from "./Scholarships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports